// AuthContext.js
import React, { createContext, useContext, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../Services/Api';
import moment from 'moment';
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [chartData, setChartData] = useState({});
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [twoFaOpen, setTwofa] = useState(false)
  const [wrongCode, setWrongCode] = useState(false)
  const tokenRefs = useRef([])
  const [userData, setUserData] = useState(null)
  const [timeOutId, setTimeOutId] = useState(null)
  const navigate = useNavigate();

  const login = async (credentials) => {

    try {
      let tokenTwo = ""
      tokenRefs.current.forEach(element => {
        tokenTwo += element.value
      });
      if (tokenTwo !== "") {
        credentials.token = tokenTwo
      }
      const response = await axiosInstance.post('/api/login', credentials);
      const data = response.data
      if (data.token) {
        setUser(data.user);
        setToken(data.token);
        setTwofa(false)
        localStorage.setItem('token', data.token);
        window.location.reload()
      } else {
        if (twoFaOpen) {
          setWrongCode(true)
        }   
        setTwofa(true)
      }
    } catch (error) {
      if(error.status === 403){
        setTwofa(false);
      }
      throw error
    }
  };

  // Função para gerar as datas dos últimos 7 dias
  function getPast7Days() {
    const labelsData = [];
    const today = moment();

    for (let i = 0; i < 7; i++) {
      const pastDate = today.clone().subtract(i, 'days');
      labelsData.push(pastDate.format('DD/MM'));
    }

    return labelsData;
  }
  const getUserdata = async (startDate, endDate) => {
    try {
      // Include startDate and endDate as query parameters
      const response = await axiosInstance.get('/api/getUserData', {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      });
      let seriesData = [];
      if (response.data.status === 0 && window.location.hash !== '#/profile') {
        window.location.href = '/#/configuracoes';
      }
      if (response.data && response.data.chartData) {
         response.data.chartData.forEach((values) => {
          seriesData.push(Number(values.total));
        });
        setChartData({
          options: {
            chart: {
              id: "basic-bar", // Consider renaming to "basic-line" for consistency
              type: "line",
              toolbar: {
                show: false
              }
            },
            stroke: {
              show: true,
              width: 2
            },
            grid: {
              show: true,
              borderColor: '#0B1739',
              strokeDashArray: 0
            },
            // Uncomment and modify if needed
            // xaxis: {
            //   categories: getPast7Days() // Assuming getPast7Days() returns valid date labels
            // }
          },
          series: [
            {
              name: "depositos",
              data: seriesData // Assuming seriesData contains valid numeric values
            }
          ],
        });

        setUserData(response.data);
      } else {
        console.warn("No or invalid chart data found in the API response.");
      }

    } catch (e) {
      if (e.response && e.response.status === 401) { // Check for response status
        window.localStorage.removeItem('token');
        window.location.reload();
      }
      console.error("Erro ao buscar dados do usuário:", e);
    }
  };
  const logout = () => {
    setUser(null);
    setToken('');
    localStorage.removeItem('token');
    window.location.reload()
  };
  const convertDateFormat = (dateString) => {
    // Divide a string da data em partes
    const [month, day] = dateString.split('-');
    // Retorna a data no formato d/m
    return `${day}/${month}`;
  };

  return (
    <AuthContext.Provider value={{ userData, setUserData, getUserdata, user, token, login, logout, twoFaOpen, setTwofa, setWrongCode, chartData, setChartData, tokenRefs, wrongCode }}>
      {children}
    </AuthContext.Provider>
  );
};



export const useAuth = () => {
  return useContext(AuthContext);
};